<template>
  <div class="sub-painel-web-atu-sessao">   
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <div v-else>
      <div style="text-align: center;">
      <b>Atenção !!</b>
      <br/>
      <br/>
      Abaixo você pode atualizar os dados da sessão de uma licença de uso ou de todos.
      <br/>
      <br/>
      Essa informação deve ser utilizada com cuidado.
      <br/>
      <hr/>
      <br/>
      </div>

      <div>
        <RF-Select2-Chosen :data-time="time" :class="campos.clu.id"
          :cpntStatus='campos.clu.status'
          :cpntId='campos.clu.id'
          :cpntClassDivField='campos.clu.classDivField'
          :cpntNome='campos.clu.nome'
          :cpntPosicaoNome='campos.clu.posicaoNome'
          :cpntValue='campos.clu.value'
          :cpntOptions='campos.clu.options'
          :cpntKeyValue='campos.clu.keyValue'
          :cpntKeyMostra='campos.clu.keyMostra'
          :cpntAutoComplete='campos.clu.autocomplete'
          :cpntDisabled='campos.clu.disabled'
          :cpntMostrar='campos.clu.mostrar'
          :cpntMensagem='campos.clu.mensagem'
          :cpntSelecioneNome='campos.clu.selecioneNome'
          :cpntSelecioneValue='campos.clu.selecioneValue'
          :cpntMensagemTipo='campos.clu.mensagemTipo'
          :cpntAdicinarOption='campos.clu.adicinarOption'
          :cpntMultiple='campos.clu.multiple'
          :cpntAllRegistro='campos.clu.allRegistro'
          :cpntExplica='campos.clu.explica'
          :cpntTabIndex='campos.clu.tabIndex'

          :cpntOnChange='campos.clu.onChange'
          :cpntOnBlur='campos.clu.onBlur'
          :ref='campos.clu.id'
        ></RF-Select2-Chosen>

        <RF-Select2 :data-time="time" :class="campos.tipo.id"
          :cpntStatus='campos.tipo.status'
          :cpntId='campos.tipo.id'
          :cpntClassDivField='campos.tipo.classDivField'
          :cpntNome='campos.tipo.nome'
          :cpntValue='campos.tipo.value'
          :cpntOptions='campos.tipo.options'
          :cpntKeyValue='campos.tipo.keyValue'
          :cpntKeyMostra='campos.tipo.keyMostra'
          :cpntAutoComplete='campos.tipo.autocomplete'
          :cpntDisabled='campos.tipo.disabled'
          :cpntMostrar='campos.tipo.mostrar'
          :cpntMensagem='campos.tipo.mensagem'
          :cpntOptionInicialNome='campos.tipo.optionInicialNome'
          :cpntOptionInicialValue='campos.tipo.optionInicialValue'
          :cpntMensagemTipo='campos.tipo.mensagemTipo'
          :cpntAddOption='campos.tipo.addOption'
          :cpntMultiple='campos.tipo.multiple'
          :cpntExplica='campos.tipo.explica'
          :cpntClassSelect='campos.tipo.classSelect2'
          :cpntTabIndex='campos.tipo.tabIndex'
          :cpntSearchMinimo='campos.tipo.searchMinimo'

          :cpntOnKeyPressEnter='campos.tipo.onKeyPressEnter'
          :cpntOnChange='campos.tipo.onChange'
          :cpntOnBlur='campos.tipo.onBlur'
          :ref='campos.tipo.id'
        ></RF-Select2>
      </div>

      <div>
        <RF-Toggles--2 :data-time="time" :class="campos.tipo.id" class="rf-input-group"
          :cpntStatus='campos.ws_imediato.status'
          :cpntId='campos.ws_imediato.id'
          :cpntClassDivField='campos.ws_imediato.classDivField'
          :cpntNome='campos.ws_imediato.nome'
          :cpntValue='campos.ws_imediato.value'
          :cpntDisabled='campos.ws_imediato.disabled'
          :cpntMostrar='campos.ws_imediato.mostrar'
          :cpntMensagem='campos.ws_imediato.mensagem'
          :cpntMensagemTipo='campos.ws_imediato.mensagemTipo'
          :cpntOptions='campos.ws_imediato.options'
          :cpntKeyValue='campos.ws_imediato.keyValue'
          :cpntKeyMostra='campos.ws_imediato.keyMostra'
          :cpntExplica='campos.ws_imediato.explica'
          :cpntTabIndex='campos.ws_imediato.tabIndex'

          :cpntOnChange='campos.ws_imediato.onChange'
          :cpntOnBlur='campos.ws_imediato.onBlur'
          :ref='campos.ws_imediato.id'
        ></RF-Toggles--2>

        <RF-Input :data-time="time" :class="campos.senha.id"
          :cpntStatus='campos.senha.status'
          :cpntId='campos.senha.id'
          :cpntTabIndex='campos.senha.tabIndex'
          :cpntClassDivField='campos.senha.classDivField'
          :cpntNome='campos.senha.nome'
          :cpntValue='campos.senha.value'
          :cpntType='campos.senha.type'
          :cpntAutoComplete='campos.senha.autocomplete'
          :cpntMask='campos.senha.mask'
          :cpntDisabled='campos.senha.disabled'
          :cpntMostrar='campos.senha.mostrar'
          :cpntAutoFocus='campos.senha.autofocus'
          :cpntMensagem='campos.senha.mensagem'
          :cpntMensagemTipo='campos.senha.mensagemTipo'
          :cpntPlaceholder='campos.senha.placeholder'
          :cpntExplica='campos.senha.explica'
          :cpntMaxLength='campos.senha.maxLength'

          :cpntOnChange='campos.senha.onChange'
          :cpntOnBlur='campos.senha.onBlur'
          :cpntOnKeyPressEnter='campos.senha.onKeyPressEnter'
          :ref='campos.senha.id'
        ></RF-Input>
      </div>

      <div class="salvar">
        <RF-Button :data-time='time'
          :cpntStatus='campos.enviar.status' 
          :cpntId='campos.enviar.id' 
          :cpntTexto='campos.enviar.texto' 
          :cpntClass='campos.enviar.class'
          :cpntMostrar='campos.enviar.mostrar'
          :cpntTabIndex='campos.enviar.tabIndex'
          @onClickButton='campos.enviar.onClick'
        ></RF-Button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sub-painel-web-atu-sessao {
  width: 655px;
}
  .sub-painel-web-atu-sessao > div {
    padding-top: 5px;
    padding-bottom: 20px;
  }
    .sub-painel-web-atu-sessao > div > div {
      padding-bottom: 10px;
      vertical-align: bottom;
    }
    .sub-painel-web-atu-sessao > div > div > .rf-input-group {
      width: 300px;
      margin-top: 0px;
    }
    .sub-painel-web-atu-sessao > div > div > .rf-input-group:not(:last-child) {
      margin-right: 10px;
    }
    .sub-painel-web-atu-sessao > div > .salvar {
      text-align: center;
    }
    .sub-painel-web-atu-sessao > div > .salvar > button {
      width: 100px;
      margin-top: -7px;
    }
</style>

<style>
  .sub-painel-web-atu-sessao > div > div > .rf-input-group,
  .sub-painel-web-atu-sessao > div > div > .rf-input-group > div,
  .rf-select2-chosen-aberto > div > div > .rf-input-group {
    margin-bottom: 0px !important;
  }

  /* .sub-painel-web-atu-sessao--clu {
    position: relative;
    top: -2px;
  } */
  /* .rf-select2-chosen-aberto {
    top: -22px;
  } */
    .sub-painel-web-atu-sessao--clu > div > button {
      width: 100%;
      height: 30px;
    }

  .sub-painel-web-atu-sessao--tipo,
  .sub-painel-web-atu-sessao--tipo > div {
    margin: 0px !important;
  }
    .sub-painel-web-atu-sessao--tipo > label {
      margin-bottom: 1px !important;
    }

  .sub-painel-web-atu-sessao--senha {
    margin-left: 10px;
    position: relative;
    top: -10px;
  }
</style>

<script>
  export default {
    components: {
      'RF-Toggles--2': () => import('@/components/rf-geral/toggles/RF-Toggles--2.vue'),
      'RF-Input': () => import('@/components/rf-geral/input/RF-Input.vue'),
      'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue'),
      'RF-Select2-Chosen': () => import('@/components/rf-geral/select2-chosen/RF-Select2-Chosen.vue'),
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          clu: {
            status: '',
            id: 'sub-painel-web-atu-sessao--clu',
            tipo: 'select2-chosen',
            nome: 'CLU',
            allRegistro: 'Todas',
            value: [ 't' ],
            multiple: true,
            keyValue: 'clu',
            keyMostra: [ 'clu', ' | ', 'cliente' ],
            apiEnv: 'clu',
            mostrar: true,
            onChange: this.subPainelWebAtuSessaoOnChange
          },
          tipo: {
            status: '',
            id: 'sub-painel-web-atu-sessao--tipo',
            tipo: 'select2',
            nome: 'Atualizar',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            optionInicialNome: '',
            options: [
              { id: 'dados_api',              nome: 'Dados Api / Data-Hora'                   },
              { id: 'token',                  nome: 'Chaves do Token'                         },
              { id: 'licenca',                nome: 'Dados do Meu Cadastro (LDU)'             },
              { id: 'usuario',                nome: 'Dados do Usuário'                        },
              { id: 'logotipo',               nome: 'Logotipo'                                },
              { id: 'menu_info',              nome: 'Informações do menu (Números menus)'     },
              { id: 'menu',                   nome: 'Menu'                                    },
              { id: 'favorito',               nome: 'Favoritos Menu'                          },
              { id: 'atualizar_web',          nome: 'Atualização WEB (Refresh na pagina)'     },
              { id: 'clu_entrada',            nome: 'CLU Entrada'                             },
              { id: 'sinesp',                 nome: 'Sinesp'                                  },
              { id: 'cod_retorno_sefaz',      nome: 'Cód Retorno Sefaz'                       },
              { id: 'usuarios',               nome: 'Usuários'                                },
              { id: 'usuarios_reg_ate',       nome: 'Usuários Registro Atendimento'           },
              { id: 'config_contato',         nome: 'Configuração de Contato'                 },
              { id: 'config_venda',           nome: 'Configuração de Venda'                   },
              { id: 'config_compra',          nome: 'Configuração de Compra'                  },
              { id: 'config_produto',         nome: 'Configuração de Produto'                 },
              { id: 'config_servico',         nome: 'Configuração de Serviço'                 },
              { id: 'ufs',                    nome: 'Estados (UFs)'                           },
              { id: 'aviso_menu',             nome: 'Avisos do Menu'                          },
              { id: 'aviso_geral',            nome: 'Avisos do Rotina Fácil'                  },
              { id: 'ultimo_acesso',          nome: 'Ultimo acesso no sistema'                }
            ],
            value: '',
            apiEnv: 'upd_sessao',
            mostrar: true,
            onChange: this.subPainelWebAtuSessaoOnChange
          },
          ws_imediato: {
            status: '',
            id: 'sub-painel-web-atu-sessao--ws_imediato',
            nome: 'Enviar Web-Socket Agora?',
            width: '135px',
            value: 'n',
            options: [ { id: 's', nome: 'Sim' }, { id: 'n', nome: 'Não' } ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            apiEnv: 'ws_imediato',
            mostrar: true,
            onChange: this.subPainelWebAtuSessaoOnChange
          },
          senha: {
            status: '',
            tamanho: 2,
            id: 'sub-painel-web-atu-sessao--senha',
            tipo: 'input',
            type: 'password',
            autocomplete: 'off',
            nome: 'Informe senha da conta ' + this.$store.state.token.conta,
            value: '',
            apiEnv: 'senha',
            autofocus: false,
            mensagem: '',
            mensagemTipo: '',
            mostrar: true,
            onChange: this.subPainelWebAtuSessaoOnChange
          },
          enviar: {
            id: 'sub-painel-web-atu-sessao--enviar',
            status: '',
            tipo: 'button',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            onClick: this.subPainelWebAtuSessaoEnviarWS
          },
        }
      }
    },
    mounted: function () {
      this.subPainelWebAtuSessaoIniciar()
    },
    methods: {
      subPainelWebAtuSessaoIniciar: function () {
        // SETA O STATUS DA TELA
        this.subPainelWebAtuSessaoSetarStatusGeral('carregando')

        // REALIZA A BUSCA DAS OPÇÕES PARA CLU
        this.subPainelWebAtuSessaoBuscarLicencas(() => { this.subPainelWebAtuSessaoSetarStatusGeral('') })
      },
      subPainelWebAtuSessaoSetarStatusGeral: function (status = '') {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subPainelWebAtuSessaoOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.campos[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.campos[index].mensagem = ''
        this.campos[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subPainelWebAtuSessaoEnviarWS: function () {
        if (confirm('Deseja realmente proseguir na atualização da sessão da(s) licença(s) selecionada(s)?')) {
          // SETA OS VALORES RECEBIDOS
          this.campos.enviar.status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = {}

          // SETA A CHAVE QUE DEVE ATUALIZAR
          formData.upd_sessao = this.campos.tipo.value
  
          // SETA A LICENÇA QUE DEVE ATUALIZAR
          formData.clu = this.campos.clu.value
  
          // VERIFICA SE ESTÁ SELECIONADO TODAS AS LDUS
          formData.clu = (formData.clu.length === 1 && formData.clu[0] === 't') ? null : JSON.stringify(formData.clu)

          // SETA SE DEVE OU NÃO ENVIAR AGORA O WS
          formData.ws_imediato = this.campos.ws_imediato.value

          // SETA A SENHA DO USUARIO
          formData.senha = this.campos.senha.value
  
          // COMUNICA COM A API PARA SALVAR OS DADOS
          this.$store.state.comunicaAPI('/subase/painel/web-upd-sessao', 'PUT', formData, (retorno) => {
            // CHAMA A FUNÇÃO PARA MOSTAR A MENSAGEM RECEBIDA DA API
            this.$store.state.TRATAR_RET_LOT_API(retorno)

            // LIMPA O CAMPO SENHA
            this.campos.senha.value = ''

            // SETA OS VALORES RECEBIDOS
            this.campos.enviar.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.subPainelWebAtuSessaoSetarStatusGeral, (apiValid, apiStatus) => {
            this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, this.campos, true, () => {
              // SETA OS VALORES RECEBIDOS
              this.campos.enviar.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          })
        }
      },
      subPainelWebAtuSessaoBuscarLicencas: function (callback = null, qtde = null, registros = []) {
        if (qtde === null || registros.length < qtde) {
          // SETA A QUERYGET QUE DEVE REALIZAR
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { clu: null, cliente: null, cnpj: null } }
  
          // SETA O WHERE DA OPERAÇÃO
          queryGet.where = { aAnd: [ { f: 'bd_internet', o: 'isNotNull' }, { f: 'bd_internet', o: '<>', v: '' } ] }
  
          // COMUNICA COM A API PARA SALVAR OS DADOS
          this.$store.state.comunicaAPI('/subase/cli-rotinafacil/get', 'POST', queryGet, (retorno) => {
            // AGRUPA OS REGISTROS RECEBIDOS
            registros = registros.concat(retorno.data)
  
            // REINICIA O PROCESSO PARA BUSCAR TODOS OS REGISTROS
            this.subPainelWebAtuSessaoBuscarLicencas(callback, Number(retorno.countAll), registros)
          }, this.subPainelWebAtuSessaoSetarStatusGeral)
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.clu.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }
      }
    }
  }
</script>
